import http from '../lib/http';

export const SELECT_CASHBOX = 'SELECT_CASHBOX';
export const RESET_SELECTED_CASHBOX_TO_DEFAULT = 'RESET_SELECTED_CASHBOX_TO_DEFAULT';

export const FETCH_ALL_ORGANIZATION_CASHBOXES_START = 'FETCH_ALL_ORGANIZATION_CASHBOXES_START';
export const FETCH_ALL_ORGANIZATION_CASHBOXES_ERROR = 'FETCH_ALL_ORGANIZATION_CASHBOXES_ERROR';
export const FETCH_ALL_ORGANIZATION_CASHBOXES_SUCCESS = 'FETCH_ALL_ORGANIZATION_CASHBOXES_SUCCESS';

export function selectCashbox(id) {
    return {
        type: 'SELECT_CASHBOX',
        payload: {id}
    };
}

export function resetSelectedCashboxToDefault() {
    return {
        type: 'RESET_SELECTED_CASHBOX_TO_DEFAULT'
    };
}

export function fetchAllOrganizationCashboxes() {
    return {
        type: 'FETCH_ALL_ORGANIZATION_CASHBOXES',
        payload: {
            promise: getAllOrganizationCashboxes()
        }
    };
}

async function getAllOrganizationCashboxes() {
    const res = await http.get(`/app/cashboxes`);
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/cashboxes/actions.js